import { create } from "zustand";
import { IUserSms } from "@/types/user.types";

export const useUserSms = create<IUserSms>((set) => ({
  dynamic: "1",
  name: "",
  phone: "",
  body: "",
  config: {},
  isDownload: false,
  setParams: (val) => {
    set((state) => {
      return { ...state, ...val };
    });
  },
  setConfig: (val) => {
    set((state) => {
      return { ...state, config: { ...state.config, ...val } };
    });
  },
  destroySms: () => {
    set({
      dynamic: "1",
      name: "",
      phone: "",
      body: "",
      isDownload: false,
      config: {},
    });
  },
}));
